import * as React from 'react';

const FormGroup = (props: any) => {
  const { children } = props;
  return <div className="form-group">{children}</div>;
};

export default FormGroup;
